<template>
    <div class="card bs-5 mb-5">
        <div class="fl-te-c pb-3">
            <h4 v-html="'SOLUTION PARTNER'"></h4>
            <div class="btn-group">
                <btn color="success" icon="fa fa-plus" size="md" @click="$refs.solutionPartnerAddModal.show()" text="Add"/>
            </div>
        </div>
        <vue-table :fields="fields" :url="listUrl" :per-page="10" ref="table">
            <template #logo="{rowData}">
                <img :src="prefix + rowData.logo" width="150px" alt="img">
            </template>
            <template #disabled="{rowData}">
                <checkbox-input v-model="rowData.disabled" @input="disable(rowData)"></checkbox-input>
            </template>
            <template #actions="{rowData}">
                <div class="btn-group-tight">
                    <delete-btn @click="setDelete(rowData)"/>
                    <edit-btn @click="setEdit(rowData)"/>
                </div>
            </template>
        </vue-table>

        <modal title="Add Solution Partner" ref="solutionPartnerAddModal" width="60r" :no-close-on-backdrop="true"
               header-color="primary">
            <AddSolutionPartner @success="formSuccess"></AddSolutionPartner>
        </modal>

        <modal title="Edit Solution Partner" ref="solutionPartnerEditModal" :no-close-on-backdrop="true" width="60r"
               header-color="primary">
            <EditSolutionPartner :initial-data="editingItem" @success="formSuccess"></EditSolutionPartner>
        </modal>

        <delete-modal ref="solutionPartnerDeleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
            <p>You are about to delete the Solution Partner <b v-html="deletingItem && deletingItem.partner_name"></b>. Are you
                sure ?
            </p>

            <template #loading>
                <loading-animation/>
                Please wait while we delete <b v-html="deletingItem && deletingItem.id"></b>.
            </template>
        </delete-modal>

    </div>
</template>

<script>
import urls from '../../../data/urls';
import AddSolutionPartner from './AddSolutionPartner';
import EditSolutionPartner from './EditSolutionPartner';
import axios from 'secure-axios';
import { mapGetters } from 'vuex';

export default {
    name       : 'Solution Partner',
    computed   : { ...mapGetters(['currentUser']) },
    components : { AddSolutionPartner, EditSolutionPartner },
    data () {
        return {
            prefix       : '',
            listUrl      : urls.admin.solutionPartner.list,
            deleteUrl    : urls.admin.solutionPartner.delete,
            editingItem  : null,
            deletingItem : null,
            fields       : [
                {
                    name       : 'name',
                    sortField  : 'name',
                    title      : 'Solution Partner Name',
                    titleClass : ''
                },
                {
                    name       : 'description',
                    sortField  : 'description',
                    title      : 'Description',
                    titleClass : ''
                },
                {
                    name       : 'website_link',
                    sortField  : 'website_link',
                    title      : 'Website Link',
                    titleClass : ''
                },
                {
                    name       : '__slot:logo',
                    sortField  : 'logo',
                    title      : 'Logo',
                    titleClass : ''
                },
                {
                    name       : '__slot:disabled',
                    sortField  : 'disabled',
                    title      : 'Disabled',
                    titleClass : ''
                },
                {
                    name       : '__slot:actions',
                    title      : 'Actions',
                    titleClass : 'center aligned text-right',
                    dataClass  : 'aligned text-right'
                }
            ]
        };
    },
    methods : {
        formSuccess () {
            const refs = this.$refs;
            refs.solutionPartnerAddModal.close();
            refs.solutionPartnerEditModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.solutionPartnerEditModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.solutionPartnerDeleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$notify('Successfully Deleted Solution Partner..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$refs.solutionPartnerDeleteModal.close();
            this.$refs.table.refreshTable();
        },
        disable (item) {
            const that = this;
            const key = {
                api_key : that.currentUser.api_key
            };
            const data = {
                ...key,
                ...item
            };
            axios.form(urls.admin.solutionPartner.addEdit, data).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                    that.$notify('Successfully Updated Solution Partner..!', 'Success',
                        {
                            type : 'success'
                        });
                } else {
                    that.$notify(json.errors, 'Error',
                        {
                            type : 'warning'
                        });
                    item.disabled = !item.disabled;
                }
            }).catch(function (err) {
                item.disabled = !item.disabled;
                console.log('error : ', err);
                that.$notify('Something went wrong..!', 'Error',
                    {
                        type : 'warning'
                    });
            });
        }
    }
};
</script>

<style scoped>

</style>
